import type { CommunityDetail } from '@pba/react-network';
import type { CommunityMember } from 'models';
import { useMemo } from 'react';

type P = {
  community: CommunityDetail;
  members?: CommunityMember[];
};

export const useCommunityMembersWithoutAdministrators = ({ community, members }: P) =>
  useMemo((): CommunityMember[] | undefined => {
    if (!members) {
      return undefined;
    }

    const administratorIds = new Set(community.administrators.map((administrator) => administrator.id));

    return members.filter((member) => !administratorIds.has(member.id));
  }, [community.administrators, members]);
